import portalApiClient from './client/portal-api';
import HttpResponse from '../http-module/http-response';

interface CartResponse {
    applicationRef: string;
    mark: {
        markWord: {
            word: string;
        } | null;
        markImage: {
            originalFileName: string;
            imageRef: string;
            originalFilePath: string;
            finalFilePath: string|null;
            uploadedAsWordImage: boolean;
        }| null;
        markContact: {
            firstName:string|null,
            lastName:string|null,
            email:string,
            phone:string|null;

        }|null;
        markOwners: {
            markOwnerType: {
                name: string,
            }|null,
            firstName: string|null,
            lastName: string|null,
            citizenCountryCode: string|null,
            businessName: string|null,
            businessNumber: string|null,
            companyNumber: string|null,
        }[];
        markOwnerDetail: {
            address: string|null,
            city: string|null,
            suburb: string|null,
            postCode: string|null,
            region: string|null,
            countryCode: string,
            email: string,
            phone: string,
        }|null;
        markGoods: {
            name: string,
            externalId: string,
            classNumber: string,
        }[];
    } | null,
}
const cart = {
    async load(countryCode: string, cartRef:string) {
        const response = await portalApiClient.get(`/${countryCode}/get-application/${cartRef}`);

        if (!(response instanceof HttpResponse)) {
            throw new Error('can\'t retrieve cart application')
        }

        return response.content.data as CartResponse;
    }
};

export default cart;


